import { CATEGORIES } from './data';
import type { CategoryKey } from './types';

interface FilterBarProps {
  active: CategoryKey | null;
  onChange: (key: CategoryKey | null) => void;
}

export function FilterBar({ active, onChange }: FilterBarProps) {
  const filterable = CATEGORIES.filter((c) => c.filterable);

  return (
    <div className="flex flex-wrap gap-1.5">
      {/* All */}
      <button
        onClick={() => onChange(null)}
        className={[
          'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors',
          active === null
            ? 'border-foreground bg-foreground text-background'
            : 'border-border bg-transparent text-muted-foreground hover:border-foreground/40 hover:text-foreground',
        ].join(' ')}
      >
        All
      </button>

      {filterable.map((cat) => {
        const Icon = cat.icon;
        const isActive = active === cat.key;
        return (
          <button
            key={cat.key}
            onClick={() => onChange(isActive ? null : cat.key)}
            className={[
              'inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              isActive
                ? 'border-foreground bg-foreground text-background'
                : 'border-border bg-transparent text-muted-foreground hover:border-foreground/40 hover:text-foreground',
            ].join(' ')}
          >
            <Icon className="h-3 w-3" />
            {cat.label}
          </button>
        );
      })}
    </div>
  );
}
